<template>
  <v-container>
    <h4>Başvuru Detayları</h4>

    <v-tabs v-model="tab" grow slider-color="#4d48f9">
      <v-tab style="text-transform: none;">Ön Başvuru</v-tab>
      <v-tab
        style="text-transform: none;"
        :disabled="!!canPreApplicationBeUpdate"
      >
        Başvuru Bilgileri
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item style="margin-top: 12px;">
        <v-text-field
          label="Mağaza Adı"
          v-model="merchantDetails.companyName"
          @input="updateData"
          :readonly="!canPreApplicationBeUpdate"
        />
        <v-text-field
          label="Yetkili Kişi Adı / Soyadı"
          v-model="merchantDetails.authorizedPerson"
          @input="updateData"
          :readonly="!canPreApplicationBeUpdate"
          :rules="fullNameRules"
        />
        <v-text-field
          label="Telefon Numarası"
          v-model="merchantDetails.phoneNumber"
          v-mask="'+90##########'"
          @input="updateData"
          :readonly="!canPreApplicationBeUpdate"
        />
        <v-text-field
          label="Eposta Adresi"
          v-model="merchantDetails.authorizedPersonMail"
          @input="onEmailChange"
          @keydown.space.prevent
          :rules="emailRules"
          :readonly="!canPreApplicationBeUpdate"
        />

        <v-textarea
          label="Adres"
          v-model="merchantDetails.companyAddress"
          maxlength="255"
          counter="255"
          rows="3"
          auto-grow
          required
          @input="updateData"
          :readonly="!canPreApplicationBeUpdate"
        ></v-textarea>

        <div style="display: flex; justify-content: space-between;">
          <div
            v-if="canPreApplicationBeUpdate"
            style="display: flex; gap: 12px;"
          >
            <v-btn
              color="success"
              class="approve-button"
              @click="updateMerchantFormStatus('PreApproved')"
              style="
                margin-top: 12px;
                max-width: 100px;
                height: 50px;
                cursor: pointer;
              "
            >
              Onayla
            </v-btn>
            <v-btn
              color="error"
              class="approve-button"
              @click="updateMerchantFormStatus('Rejected')"
              style="
                margin-top: 12px;
                max-width: 100px;
                height: 50px;
                cursor: pointer;
              "
            >
              Reddet
            </v-btn>
          </div>
          <div v-else></div>
          <v-btn
            class="approve-button"
            @click="submitApplyForm()"
            style="margin-top: 12px; max-width: 100px; height: 50px;"
            :disabled="isButtonDisabled || !canPreApplicationBeUpdate"
          >
            Güncelle
          </v-btn>
        </div>
      </v-tab-item>

      <v-tab-item style="margin-top: 12px;">
        <v-card-text>
          <v-row style="margin-top: 20px;">
            <v-col cols="12" md="4">
              <v-text-field
                label="Mağaza Sahibi Adı / Soyadı"
                v-model="merchantDetails.ownerName"
                :readonly="isApplicationReadOnly"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Ticaret Ünvanı"
                v-model="merchantDetails.companyTitle"
                :readonly="isApplicationReadOnly"
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                label="Kep Adresi"
                v-model="merchantDetails.kepAddress"
                @input="updateData"
                :readonly="isApplicationReadOnly"
              />
            </v-col>
          </v-row>

          <v-row style="margin-top: 20px;">
            <v-col cols="12" md="4">
              <v-text-field
                label="Şirket Eposta Adresi"
                v-model="merchantDetails.companyMail"
                @input="onEmailChange"
                @keydown.space.prevent
                :rules="emailRules"
                :readonly="isApplicationReadOnly"
              />
            </v-col>
            <v-col cols="12" md="8">
              <div style="margin-top: 20px; color: darkslategray;">
                Şirket Türü
              </div>

              <v-radio-group
                v-model="merchantDetails.companyType"
                row
                style="margin-left: 8px;"
                :readonly="isApplicationReadOnly"
              >
                <v-radio value="Individual" class="custom_radio">
                  <template v-slot:label>
                    <v-img
                      :src="require('../../../assets/icons/individual.svg')"
                      contain
                      class="mr-2"
                    />
                    <div>
                      Şahıs
                    </div>
                  </template>
                </v-radio>
                <v-radio value="Limited" class="custom_radio">
                  <template v-slot:label>
                    <v-img
                      :src="require('../../../assets/icons/limited.svg')"
                      contain
                      class="mr-2"
                    />
                    <div>
                      Limited
                    </div>
                  </template>
                </v-radio>
                <v-radio value="Stock" class="custom_radio">
                  <template v-slot:label>
                    <v-img
                      :src="require('../../../assets/icons/anonim.svg')"
                      contain
                      class="mr-2"
                    />
                    <div>
                      Anonim
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row style="margin-top: 20px;">
            <v-col cols="12" md="4">
              <v-text-field
                label="Hesap Adı"
                v-model="merchantDetails.accountName"
                required
                @input="updateData"
                :readonly="isApplicationReadOnly"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="IBAN"
                v-mask="'TR## #### #### #### #### #### ##'"
                v-model="merchantDetails.iban"
                required
                @input="onIbanChange"
                :readonly="isApplicationReadOnly"
                maxlength="32"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Banka Adı"
                v-model="merchantDetails.bankName"
                required
                readonly
              />
            </v-col>
          </v-row>
          <v-row style="margin-top: 20px;">
            <v-col cols="12" md="4">
              <v-text-field
                label="Yetkili Kişi Adı / Soyadı"
                v-model="merchantDetails.authorizedPerson"
                @input="updateData"
                :readonly="isApplicationReadOnly"
                :rules="fullNameRules"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Yetkili Ünvanı"
                v-model="merchantDetails.authorizedPersonTitle"
                @input="updateData"
                :readonly="isApplicationReadOnly"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Eposta Adresi"
                v-model="merchantDetails.authorizedPersonMail"
                @input="updateData"
                :rules="emailRules"
                :readonly="isApplicationReadOnly"
              />
            </v-col>
          </v-row>
          <v-row style="margin-top: 20px;">
            <v-col cols="12" md="4">
              <v-text-field
                label="Mağaza Adı"
                v-model="merchantDetails.companyName"
                @input="updateData"
                :readonly="isApplicationReadOnly"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-textarea
                label="Adres"
                v-model="merchantDetails.companyAddress"
                maxlength="255"
                counter="255"
                rows="3"
                auto-grow
                required
                @input="updateData"
                :readonly="isApplicationReadOnly"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Telefon Numarası"
                v-model="merchantDetails.phoneNumber"
                v-mask="'+90##########'"
                @input="updateData"
                :readonly="isApplicationReadOnly"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <div style="margin-top: 20px; color: darkslategray;">
                Anlaşma Tipi
              </div>
              <v-radio-group
                v-model="merchantDetails.subscriptionType"
                row
                style="margin-left: 8px;"
                :readonly="isApplicationReadOnly"
              >
                <v-radio value="BASIC" class="custom_radio">
                  <template v-slot:label>
                    <v-img
                      :src="require('../../../assets/icons/basic-package.svg')"
                      contain
                      class="mr-2"
                    />
                    <div>
                      Basic Paket
                    </div>
                  </template>
                </v-radio>
                <v-radio value="PLUS" class="custom_radio">
                  <template v-slot:label>
                    <v-img
                      :src="require('../../../assets/icons/plus-package.svg')"
                      contain
                      class="mr-2"
                    />
                    <div>
                      Plus Paket
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="6">
              <div style="margin-top: 16px; color: darkslategray;">
                Süt Seçenekleri
              </div>
              <div class="custom-checkboxes" style="margin-top: 8px;">
                <v-checkbox
                  v-for="milk in milkTypes"
                  :key="milk.type"
                  color="#12B76A"
                  :label="milk.text"
                  v-model="merchantDetails.milkType"
                  :value="milk.type"
                  :readonly="isApplicationReadOnly"
                ></v-checkbox>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <div style="margin-top: 20px; color: darkslategray;">
                Bardak Boyları
              </div>
              <div class="custom-checkboxes" style="margin-top: 8px;">
                <div
                  v-for="size in coffeeSizes"
                  :key="size.type"
                  @click="onSelectCoffeeSize(size.type)"
                  :class="[
                    {
                      'custom-checkbox-active':
                        merchantDetails.coffeeSizeType &&
                        merchantDetails.coffeeSizeType.indexOf(size.type) !==
                          -1,
                    },
                    'custom-checkbox',
                  ]"
                >
                  <div>
                    <v-img
                      :src="require('../../../assets/icons/cup.svg')"
                      contain
                      class="mr-2"
                      :style="{ height: size.imgHeight }"
                    />
                    <div>
                      {{ size.text }}
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label="Vergi Dairesi"
                v-model="merchantDetails.taxOffice"
                @input="updateData"
                :readonly="isApplicationReadOnly"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="Vergi Kimlik No"
                v-model="merchantDetails.taxIdNumber"
                @input="updateData"
                :readonly="isApplicationReadOnly"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-textarea
                label="Fatura Adresi"
                v-model="merchantDetails.invoiceAddress"
                @input="updateData"
                :readonly="isApplicationReadOnly"
                maxlength="255"
                counter="255"
                rows="3"
                auto-grow
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <span>Vergi Levhası</span>
              <div style="margin-top: 4px; font-size: 12px;">
                Güncel dosyaya
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <a
                      :href="merchantDetails.taxPlateUrl"
                      target="_blank"
                      v-bind="props"
                      @click.stop
                    >
                      buradan
                    </a>
                  </template>
                </v-tooltip>
                ulaşabilirsiniz.
              </div>
              <v-file-input
                show-size
                v-model="merchantDetails.taxPlate"
                label="Dosya yükle"
                @change="updateData"
                accept="image/jpg, image/jpeg, image/png, application/pdf"
                :rules="fileRules"
                :style="{
                  pointerEvents: isApplicationReadOnly ? 'none' : 'inherit',
                }"
              ></v-file-input>
            </v-col>
            <v-col cols="12" md="6">
              <span>Faaliyet Belgesi</span>
              <div style="margin-top: 4px; font-size: 12px;">
                Güncel dosyaya
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <a
                      :href="merchantDetails.certificateOfActivityUrl"
                      target="_blank"
                      v-bind="props"
                      @click.stop
                    >
                      buradan
                    </a>
                  </template>
                </v-tooltip>
                ulaşabilirsiniz.
              </div>
              <v-file-input
                show-size
                v-model="merchantDetails.certificateOfActivity"
                label="Dosya yükle"
                @change="updateData"
                accept="image/jpg, image/jpeg, image/png, application/pdf"
                :rules="fileRules"
                :style="{
                  pointerEvents: isApplicationReadOnly ? 'none' : 'inherit',
                }"
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <span>İmza Sirküleri</span>
              <div style="margin-top: 4px; font-size: 12px;">
                Güncel dosyaya
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <a
                      :href="merchantDetails.signatureCircularUrl"
                      target="_blank"
                      v-bind="props"
                      @click.stop
                    >
                      buradan
                    </a>
                  </template>
                </v-tooltip>
                ulaşabilirsiniz.
              </div>
              <v-file-input
                show-size
                v-model="merchantDetails.signatureCircular"
                label="Dosya yükle"
                @change="updateData"
                accept="image/jpg, image/jpeg, image/png, application/pdf"
                :rules="fileRules"
                :style="{
                  pointerEvents: isApplicationReadOnly ? 'none' : 'inherit',
                }"
              ></v-file-input>
            </v-col>
            <v-col>
              <span>Ticaret Sicil Kaydı</span>
              <div style="margin-top: 4px; font-size: 12px;">
                Güncel dosyaya
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <a
                      :href="merchantDetails.tradeRegistryRecordUrl"
                      target="_blank"
                      v-bind="props"
                      @click.stop
                    >
                      buradan
                    </a>
                  </template>
                </v-tooltip>
                ulaşabilirsiniz.
              </div>
              <v-file-input
                show-size
                v-model="merchantDetails.tradeRegistryRecord"
                label="Dosya yükle"
                @change="updateData"
                accept="image/jpg, image/jpeg, image/png, application/pdf"
                :rules="fileRules"
                :style="{
                  pointerEvents: isApplicationReadOnly ? 'none' : 'inherit',
                }"
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <span>Sözleşme</span>
              <div style="margin-top: 4px; font-size: 12px;">
                Güncel dosyaya
                <v-tooltip location="bottom">
                  <template v-slot:activator="{ props }">
                    <a
                      :href="merchantDetails.contractUrl"
                      target="_blank"
                      v-bind="props"
                      @click.stop
                    >
                      buradan
                    </a>
                  </template>
                </v-tooltip>
                ulaşabilirsiniz.
              </div>
              <v-file-input
                show-size
                v-model="merchantDetails.contract"
                label="Dosya yükle"
                @change="updateData"
                accept="image/jpg, image/jpeg, image/png, application/pdf"
                :rules="fileRules"
                :style="{
                  pointerEvents: isApplicationReadOnly ? 'none' : 'inherit',
                }"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>

        <div style="display: flex; justify-content: space-between;">
          <div
            v-if="isApplicationReadyForCompleteOrReject"
            style="display: flex; gap: 12px;"
          >
            <v-btn
              color="success"
              class="approve-button"
              @click="updateMerchantFormStatus('Completed')"
              style="
                margin-top: 12px;
                max-width: 100px;
                height: 50px;
                cursor: pointer;
              "
              :disabled="isButtonDisabled"
            >
              Onayla
            </v-btn>
            <v-btn
              color="error"
              class="approve-button"
              @click="updateMerchantFormStatus('Rejected')"
              style="
                margin-top: 12px;
                max-width: 100px;
                height: 50px;
                cursor: pointer;
              "
            >
              Reddet
            </v-btn>
          </div>
          <div v-else></div>
          <v-btn
            class="approve-button"
            @click="submitApplyForm()"
            style="margin-top: 12px; max-width: 100px; height: 50px;"
            :disabled="isButtonDisabled || !isApplicationReadyForCompleteOrReject"
          >
            Güncelle
          </v-btn>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MerchantApplicationDetails',
  computed: mapGetters('applyMerchantForm', ['merchantDetails']),
  methods: {
    ...mapActions('applyMerchantForm', [
      'getMerchantApplicationDetails',
      'fetchBankNameByIban',
      'setMerchantApplicationDetails',
      'putApplyMerchantForm',
      'putAppliedMerchantStatus',
    ]),
    onSelectCoffeeSize(size) {
      if (!this.isApplicationReadOnly) {
        let oldCoffeeSizes = this.merchantDetails.coffeeSizeType || []
        let newCoffeeSizes = oldCoffeeSizes.includes(size)
          ? oldCoffeeSizes.filter((x) => x !== size)
          : [...oldCoffeeSizes, size]

        this.merchantDetails.coffeeSizeType = newCoffeeSizes
        this.updateData()
      }
    },
    onSelectMilkType(milkType) {
      let oldMilkTypes = this.merchantDetails.milkType || []
      let newMilkTypes = oldMilkTypes.includes(milkType)
        ? oldMilkTypes.filter((x) => x !== milkType)
        : [...oldMilkTypes, milkType]

      this.merchantDetails.milkType = newMilkTypes
      //   this.$emit('update-form-data', 'storeInfo', this.merchantDetails)
      this.updateData()
    },
    updateData() {
      // this.$emit('update-form-data', 'companyInfo', this.localData)
      this.setMerchantApplicationDetails(this.merchantDetails)
      this.validCheck()
    },
    onEmailChange(value) {
      this.merchantDetails.companyMail = value.replaceAll(/\s+/g, '')
      this.updateData()
    },
    onIbanChange() {
      const trimmedIban = this.merchantDetails.iban.replaceAll(' ', '')
      if (trimmedIban.length === 26) {
        this.fetchBankNameByIban(trimmedIban).then((res) => {
          if (res.processStatus === 'Success') {
            this.merchantDetails.bankName = res.payload.bankName
          }
          this.$nextTick(() => {
            this.updateData()
          })
        })
      } else if (this.merchantDetails.bankName !== '') {
        this.merchantDetails.bankName = ''
        this.$nextTick(() => {
          this.updateData()
        })
      } else {
        this.updateData()
      }
    },
    validCheck() {
      const data = this.merchantDetails
      let isValid =
        !!(data.companyName && data.companyName.trim()) &&
        !!(data.authorizedPerson && data.authorizedPerson.trim()) &&
        !!(data.companyAddress && data.companyAddress.trim()) &&
        !!(data.phoneNumber && data.phoneNumber.trim().length === 13) &&
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
          data.authorizedPersonMail,
        )
      if (!this.isApplicationReadOnly) {
        isValid =
          isValid &&
          !!data.ownerName &&
          !!data.companyName &&
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
            data.companyMail,
          ) &&
          !!data.iban &&
          !!data.accountName &&
          !!data.bankName &&
          !!data.authorizedPersonTitle &&
          !!data.subscriptionType &&
          !!data.taxOffice &&
          !!data.taxIdNumber &&
          !!data.invoiceAddress &&
          !!data.coffeeSizeType.length &&
          !!data.milkType.length &&
          (!!data.taxPlate || !!data.taxPlateUrl) &&
          (!!data.certificateOfActivity || !!data.certificateOfActivityUrl) &&
          (!!data.signatureCircular || !!data.signatureCircularUrl) &&
          (!!data.tradeRegistryRecord || !!data.tradeRegistryRecordUrl) &&
          (!!data.contract || !!data.contractUrl)
      }
      this.isButtonDisabled = !isValid
    },
    fetchMerchantApplicationDetails() {
      let id = this.$route.params.id
      this.getMerchantApplicationDetails(id).then((response) => {
        const { status } = response

        const readOnlyStatuses = [
          'Rejected',
          'AwaitingStoreOpening',
          'Completed',
        ]

        if (readOnlyStatuses.includes(status)) {
          // this.!canPreApplicationBeUpdate = true
          this.isApplicationReadOnly = true
          this.isApplicationReadyForCompleteOrReject = false
          this.canPreApplicationBeUpdate = false
        } else {
          // this.!canPreApplicationBeUpdate = status !== 'NewApplication'
          this.isApplicationReadOnly = status !== 'PendingApproval'
          this.canPreApplicationBeUpdate = [
            'NewApplication',
            'PendingPreApproval',
          ].includes(status)

          this.isApplicationReadyForCompleteOrReject = [
            'PendingApproval',
            'AwaitingStoreOpening',
          ].includes(status)
        }
      })
    },
    submitApplyForm() {
      this.putApplyMerchantForm(this.localData).then((response) => {
        if (response.payload) {
          alert('Başarıyla Güncellendi')
          this.fetchMerchantApplicationDetails()
        }
      })
    },
    updateMerchantFormStatus(status) {
      this.putAppliedMerchantStatus({
        id: this.$route.params.id,
        status: status,
      }).then((isUpdated) => {
        if (isUpdated) {
          if (status === 'Rejected') alert('Başarıyla Reddedildi.')
          else alert('Başarıyla Onaylandı.')
        }
        this.fetchMerchantApplicationDetails()
      })
    },

    //   routeUsers() {
    //     this.$router.push('/dashboard/merchant-onboardings')
    //   },
  },
  data: () => ({
    emailRules: [
      (v) => !!v || 'Email alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'Lütfen geçerli bir mail adresi giriniz.',
    ],
    fileRules: [
      (v) => !!v || 'Dosya gereklidir.',
      (v) => (v && v.name != null) || 'Dosya gereklidir.',
      (v) =>
        !v || v.size <= 10000000 || 'Maksimum dosya boyutunu aştınız (10MB).',
    ],
    fullNameRules: [
      (v) => !!v || 'Ad ve soyadı doğru bir formatta yazınız.',
      (v) => v.length <= 255 || 'Ad ve soyadı doğru bir formatta yazınız.',
      (v) => {
        const parts = v
          .trim()
          .split(' ')
          .filter((part) => part.length > 0)
        return (
          (parts.length >= 2 && parts.every((part) => part.length >= 2)) ||
          'Ad ve soyadı doğru bir formatta yazınız.'
        )
      },
      (v) =>
        /^[A-Za-zğüşıöçĞÜŞİÖÇ\s]*$/.test(v) ||
        'Ad ve soyadı doğru bir formatta yazınız.',
    ],
    coffeeSizes: [
      {
        type: 'Small',
        text: 'Küçük',
        imgHeight: '48px',
      },
      {
        type: 'Medium',
        text: 'Orta',
        imgHeight: '64px',
      },
      {
        type: 'Large',
        text: 'Büyük',
        imgHeight: '80px',
      },
    ],
    milkTypes: [
      {
        type: 'LowFat',
        text: 'Az Yağlı',
      },
      {
        type: 'LactoseFree',
        text: 'Laktozsuz',
      },
      {
        type: 'WithoutMilk',
        text: 'Sütsüz',
      },
      {
        type: 'FullFat',
        text: 'Tam Yağlı',
      },
    ],
    isButtonDisabled: true,
    tab: 0,
    // !canPreApplicationBeUpdate: false,
    isApplicationReadOnly: false,
    canPreApplicationBeUpdate: false,
    isApplicationReadyForCompleteOrReject: false,
  }),
  created() {
    this.fetchMerchantApplicationDetails()
    this.validCheck()
  },
}
</script>
